import React from 'react';
import styled from 'styled-components';
import icon from './../../images/icons/info_circle.svg';
import Text from '../../ui/Text';
import { detectMobile } from '../../utils/UiHelper';
import { breakpoint } from '../../constants/breakpoints';

const HintWrapper = styled.div`
    width: ${(props) => (props.width ? props.width : '100%')};
    height: ${(props) => (props.height ? props.height : 'auto')};
    margin: 20px 0 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    min-height: ${(props) => (props.minHeight ? props.minHeight : 'auto')};
    padding: 13px 20px;
    border: 1px solid #d3e3fb;
    border-radius: 5px;
    background: #e4effe;
    img {
        box-sizing: border-box;
        display: inline-block;
        margin-right: 10px;
    }
    @media screen and ${breakpoint.S} {
        margin: 16px auto 0;
        width: ${(props) => (props.width ? props.width : 'calc(100% - 36px)')};
    }
`;

const Hint = ({ title, label, breakTitle = false }) => {
    return (
        <HintWrapper>
            <img src={icon} alt="hint" />
            <Text
                size={'12'}
                lh={'18'}
                color={'#333333'}
                margin={'0'}
                padding={'0'}
            >
                <b>{title}</b>
                {detectMobile() && breakTitle ? <br /> : null}
                {` `}
                {label}
            </Text>
        </HintWrapper>
    );
};

export default Hint;
